
import {
  Box, SimpleGrid, useColorModeValue
} from "@chakra-ui/react";
import BussinessModelForm from "./components/Form";
import BussinessModelTable from "./components/Table";
import useBussinesModel from "./hooks/useBussinesModel";

export default function BussinesModelScreen() {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  const {
    modeloNegocio,
    add,
    edit,
    loading,
    show,
    showModal,
    accountSelected,
    error,
    save,
    showDelete,
    showDeleteModal,
    cancelRef,
    closeDelete,
    deletar,
    changeInput,
    closeError,
    errorMsg,
    errorTitle,
  } = useBussinesModel();

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <BussinessModelTable
          add={add}
          edit={edit}
          list={modeloNegocio}
          deletar={showDeleteModal}
          showDelete={showDelete}
          cancelRef={cancelRef}
          closeDelete={closeDelete}
          remove={deletar}
        />
        <BussinessModelForm
          accountSelected={accountSelected}
          brandStars={brandStars}
          cancelRef={cancelRef}
          changeInput={changeInput}
          closeError={closeError}
          error={error}
          errorMsg={errorMsg}
          errorTitle={errorTitle}
          loading={loading}
          save={save}
          show={show}
          showModal={showModal}
          textColor={textColor}
        
        />

      </SimpleGrid>
    </Box>
  );
}
